import React from 'react';
import styled from 'styled-components';
import { primaryMain } from 'crehana-ui/styles/colors';

const Progress = styled.span<{ progress: number }>`
  width: ${props => props.progress}%;
  height: 4px;
  background-color: ${primaryMain};
`;

const ProgressLine = ({ progress }) => {
  return (
    <div className="relative bg-gray-lighter w-full">
      <Progress className="block" progress={progress} />
    </div>
  );
};

export default ProgressLine;
